import { render } from "./payment-method-form.vue?vue&type=template&id=6afe81f6&scoped=true"
import script from "./payment-method-form.vue?vue&type=script&lang=js"
export * from "./payment-method-form.vue?vue&type=script&lang=js"

import "./payment-method-form.vue?vue&type=style&index=0&id=6afe81f6&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afe81f6"]])

export default __exports__